import $ from 'jquery';
import * as common from '../../../../shared/modules/common';
import { hasInputEvent } from '../../../../shared/modules/support';
import { render } from 'mustache';
import view from './formatterView';

//                         IE8 fix           IE9 fix
var onTypingEventName = !hasInputEvent || common.isIe9() ? 'keyup' : 'input',
    FormatterModes = {
        /* Internal mode description objects
            * Parameters:
            *  - initEvent: string, on what HTML event should be the field content initialized for editing.
            *    Default: undefined
            *  - formatEvent: string, on what HTML event should the value be formatted.
            *    Default: undefined
            *  - syncValueEvent: string, on what HTML event should the raw value written in the original field.
            *    Default: undefined
            *  - handleSelection: boolean, should the caret position saved and restored or not.
            *    Default: false
            *  - editUnformattedValue: boolean: should the unformatted value edited instead of the formatted.
            *    Default: false
            */
        onedit: {
            formatEvent: onTypingEventName,
            handleSelection: true
        },
        onblur: {
            /* The IE does not handle mousedown and moving the mouse to select a text, if the value is overwritten
                * by a script on the focus event. To avoid the issue, we changed the init event for all browsers to
                * mousedown. It works, however it updates the field content on every mousedown in the field.
                * (UBSWI-1703)
                */
            initEvent: 'mousedown',
            formatEvent: 'blur',
            syncValueEvent: onTypingEventName,
            handleSelection: false,
            editUnformattedValue: true
        }
    },
    DefaultFormatterModes = {
        'uwr.formatter.date': 'onedit',
        'uwr.formatter.number': 'onblur'
    }
;


function getSelectionState(target) {
    return {
        target: target,
        selectionStart: target.selectionStart,
        selectionEnd: target.selectionEnd,
        valueStringLength: target.value.length
    };
}

function restoreSelection(selectionState, formatResult) {
    var range; // IE8
    if (formatResult && selectionState.selectionStart === selectionState.valueStringLength) {
        selectionState.selectionStart = formatResult.formatted.length;
    }
    if (formatResult && selectionState.selectionEnd === selectionState.valueStringLength) {
        selectionState.selectionEnd = formatResult.formatted.length;
    }

    if (selectionState.target.setSelectionRange) {
        selectionState.target.setSelectionRange(selectionState.selectionStart, selectionState.selectionEnd);
    } else { // IE8 -->
        range = document.selection.createRange();
        range.move('textedit', 1);
        range.select();
    } // <-- IE8
}

function getValueDiff(oldValue, newValue) {
    var valueDifference = '';
    oldValue = oldValue || '';
    while (newValue.length > 0 && oldValue.length > 0) {
        if (newValue.charAt(0) === oldValue.charAt(0)) {
            oldValue = oldValue.substring(1);
        } else {
            valueDifference = newValue.charAt(0);
        }
        newValue = newValue.substring(1);
    }
    valueDifference += newValue;
    return valueDifference;
}

function getPreviousContent(hintElement) {
    var hintHiddenPartElement = hintElement.parentNode.querySelector('.uwr-input-hint-hidden');
    return hintHiddenPartElement.textContent || hintHiddenPartElement.innerText || '';
}

function setHintContent(formatResult, visibleField) {
    var hintElement = visibleField.parentNode.querySelector('.uwr-input-hint .uwr-input-hint-visible'),
        hintHiddenPartElement = hintElement.parentNode.querySelector('.uwr-input-hint-hidden'),
        hintContent = formatResult.formatted.length > 0 && formatResult.hint ? formatResult.hint : '';

    if (hintElement.textContent !== undefined) { // IE9+
        hintElement.textContent = hintContent;
        hintHiddenPartElement.textContent = formatResult.formatted;
    } else { // IE8
        hintElement.innerText = hintContent;
        hintHiddenPartElement.innerText = formatResult.formatted;
    }
}

/**
 *
 * @param fields It contains two optional elements: original and visible. If an element is undefined, then the
 *               related updates are skipped.
 * @param formatResult The formatter result object, which is the base of the update.
 */
function updateViewAndModel(fields, formatResult) {
    if (fields.visible) {
        fields.visible.value = formatResult.formatted;
        setHintContent(formatResult, fields.visible);
    }
    if (fields.original) {
        fields.original.value = formatResult.raw;
    }
}

/**
 * IE9 and IE8 hacks for ms-clear X button within the input field
 * This handles the drag and cut/paste events as well
 */
function setIEBlurHandlersForMSClear(visibleField, formatterMode) {
    var interval,
        lastLength = 1,
        inputHandler = function inputHandler() {
            var hintElement = visibleField.parentNode.querySelector('.uwr-input-hint .uwr-input-hint-visible'),
                hintHiddenPartElement =
                    visibleField.parentNode.querySelector('.uwr-input-hint .uwr-input-hint-hidden');

            if (visibleField.value.length < 1) {
                // Support IE8 too
                hintElement.innerText = '';
                hintHiddenPartElement.innerText = '';
            }
        },
        checkInterval = function checkInterval() { // IE9 ms-clear and cut hint handling
            if (visibleField.value.length !== lastLength) {
                common.dispatchEvent('keyup', visibleField);
            }
            lastLength = visibleField.value.length;
        },
        setupCheckInterval = function setupCheckInterval() {
            interval = setInterval(checkInterval, 500);
        },
        clearCheckInterval = function clearCheckInterval() {
            clearInterval(interval);
            checkInterval();
        };

    if (common.isIe9()) {
        common.addEventListener('blur', visibleField, inputHandler);
        if (formatterMode.formatEvent === 'keyup') {
            common.addEventListener('focus', visibleField, setupCheckInterval);
            common.addEventListener('blur', visibleField, clearCheckInterval);
        }
    } else if (visibleField && visibleField.attachEvent) {
        visibleField.attachEvent('onpropertychange', inputHandler);
    }
}

function createFormatterEventHandler(originalField, visibleField, valueFormatter, formatterMode) {
    return function (event) {
        var target = common.getEventTarget(event, true),
            rawValue = target.value,
            selectionState,
            hintElement =
                visibleField.parentNode.querySelector('.uwr-input-hint .uwr-input-hint-visible'),
            formatResult =
                valueFormatter.format(rawValue,
                    getValueDiff(getPreviousContent(hintElement), rawValue)
                );

        // Break infinite blur-focus loop on caret positioning
        if (formatterMode.handleSelection) {
            selectionState = getSelectionState(target);
            updateViewAndModel({original: originalField, visible:visibleField}, formatResult);
            restoreSelection(selectionState, formatResult);
        } else {
            updateViewAndModel({original: originalField, visible: visibleField}, formatResult);
        }
    };
}

function createInitializationEventHandler(originalField, formatterMode) {
    return function (event) {
        var target = common.getEventTarget(event, true),
            selectionState;

        if (originalField.value !== undefined) {
            selectionState = getSelectionState(target);
            if (formatterMode.editUnformattedValue) {
                target.value = originalField.value;
            }
            restoreSelection(selectionState);
        }
    };
}

function createSyncValueEventHandler(originalField, valueFormatter) {
    return function (event) {
        var target = common.getEventTarget(event, true),
            rawValue = target.value,
            formatResult = valueFormatter.format(rawValue);
        updateViewAndModel({original: originalField}, formatResult);
    };
}

/**
 * It gives back the valueFormatter defined on the markup or undefined.
 * @param {Object} $markup The jQuery markup object.
 * @returns {{mode: string, formatterMode: Object, format: Function}}
 */
function getValueFormatter($markup) {
    var valueFormatterName = common.data($markup, 'formatter'),
        valueFormatterObject,
        valueFormatter = {};

    if (valueFormatterName) {
        valueFormatterObject = valueFormatterName ? common.resolveReferencedObject(valueFormatterName) : {};
        valueFormatter.mode = valueFormatterObject.mode || DefaultFormatterModes[valueFormatterName];
        if (valueFormatter.mode) {
            valueFormatter.formatterMode = FormatterModes[valueFormatter.mode];
            valueFormatter.format = valueFormatterObject.format;
        }
    }

    return valueFormatter.format && valueFormatter.formatterMode ? valueFormatter : undefined;
}

function setupVisibleField($markup, formattedValue) {
    var originalField = $markup.get(0),
        $visibleField = ($(render(view.visibleField, []))),
        visibleField = $visibleField.get(0);

    $markup.after($visibleField);
    common.copyAttributesIfExist(originalField, visibleField, ['disabled', 'readonly', 'type']);
    $visibleField.before($(render(view.hinterBox, [])));

    updateViewAndModel({visible: visibleField}, formattedValue);

    return visibleField;
}

function setupEventHandlers(originalField, visibleField, valueFormatter) {
    var formatterMode = valueFormatter.formatterMode;

    // Set formatting event
    if (formatterMode.formatEvent) {
        common.addEventListener(formatterMode.formatEvent, visibleField,
            createFormatterEventHandler(originalField, visibleField, valueFormatter, formatterMode)
        );
    }
    // Set initialization event
    if (formatterMode.initEvent) {
        common.addEventListener(formatterMode.initEvent, visibleField,
            createInitializationEventHandler(originalField, formatterMode)
        );
    }
    // Set field synchronization event (syncing value between the original and the visible fields)
    if (formatterMode.syncValueEvent) {
        common.addEventListener(formatterMode.syncValueEvent, visibleField,
            createSyncValueEventHandler(originalField, valueFormatter)
        );
    }
    // IE8, IE9 ms-clear
    setIEBlurHandlersForMSClear(visibleField, formatterMode);
}

export function init($markup) {
    var valueFormatter = getValueFormatter($markup),
        visibleField,
        originalField = $markup.get(0);

    if (valueFormatter) {

        visibleField = setupVisibleField($markup, valueFormatter.format(originalField.value));
        setupEventHandlers(originalField, visibleField, valueFormatter);
        common.forwardEvents(['change', 'input'], visibleField, originalField);

        // This is the input behavior context change, see more in the input.js
        return {
            visibleInputField: visibleField
        };
    }
}



//////////////////
// WEBPACK FOOTER
// ./widgets/Input/features/js/formatter.js
// module id = 89
// module chunks = main